module.exports = __webpack_public_path__ + "static/media/child_p3.f22f6835.png";